import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import FloatingChatButton from "../../components/button/FloatingChatButton";
import OrderInfoDialogBox from "../../components/dialogBox/OrderInfoDialogBox";
import Footer from "../../components/footer/Footer";
import ContactForm from "../../components/form/ContactForm";
import Navbar from "../../components/navbar/Navbar";
import OrderSummaryCard from "../../components/order/OrderSummaryCard";
import H2 from "../../components/typography/H2";
import { usePopup } from "../../context/PopupContext";
import { cartService } from "../../service/CartService";
import { orderService } from "../../service/OrderService";

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  margin: 0px 5%;
  h2 {
    text-align: center;
  }
`;

const Space = styled.div`
  height: 20px;
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  gap: 50px;
  flex: 1;
  position: relative;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
`;

const Form = styled.div`
  flex: 1;
`;

const CheckoutDetails = styled.div`
  /* flex-shrink: 0; */
  display: flex;
  flex-direction: column;
  gap: 40px;
  position: sticky;
  top: 180px;
  height: fit-content;
  max-height: calc(100vh - 200px);
  overflow-y: auto;

  @media (max-width: 1000px) {
    width: fit-content;
    margin: auto;
    position: relative;
    top: 0;
    max-height: none;
  }
`;

function OrderPage() {
  const [cart, setCart] = useState();
  const [data, setData] = useState();
  const [isValid, setIsValid] = useState(false);
  const { showPopup } = usePopup();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCart = async () => {
      cartService.getCart().then((res) => {
        setCart(res);
      });
    };
    fetchCart();
  }, []);

  const handleOrder = async () => {
    const payload = {
      items: cart,
      ...data,
    };

    if (isValid) {
      orderService.createOrder(
        payload,
        () => {
          showPopup(
            `Your order has been placed..`,
            "You will receive an email shortly. Continue shopping more."
          );
          cartService.clearCart();
          navigate("/products");
        },
        {
          default: (message) => alert(message),
        }
      );
    } else {
      alert("Enter the field properly");
    }
  };

  return (
    <Wrapper>
      <FloatingChatButton />
      <Navbar />
      <Space />
      <Space />
      <Container>
        <H2>Order Details</H2>
        <Space />
        <Space />
        <Flex>
          <Form>
            <ContactForm setData={setData} isValid={setIsValid} />
          </Form>
          <CheckoutDetails>
            {cart && (
              <OrderSummaryCard
                actionText={"Place Order"}
                actionOnClick={() => {
                  handleOrder();
                }}
                cart={cart}
              />
            )}
            <OrderInfoDialogBox />
          </CheckoutDetails>
        </Flex>
      </Container>
      <Space />
      <Space />
      <Footer />
    </Wrapper>
  );
}

export default OrderPage;
